import React from "react";
import { useSelector } from "react-redux";
import DecisionBox from "../DecisionBox/DecisionBox";
import { debateFormatEnum } from "../../../utils/enum";
import styles from "./CoachDecision.module.css";

// Dummy positionIcons (since it's not provided in the original code)
const positionIcons = {
  1: "1st",
  2: "2nd",
  3: "3rd",
  4: "4th",
};

const CoachDecision = ({
  debateType,
  debateState,
  teams, // Added teams prop to pass to DecisionBox
  judgeDecision,
  dispatch,
  JudgeDebate,
}) => {
  const { data } = useSelector((state) => state.user);

  const isCoach = data?.isCoach;
  const displayResult = judgeDecision.showResult;
  const isWaitingForCoachDecision = !displayResult && !isCoach;
  const displayDecisionDashboard = !displayResult && isCoach;

  return (
    <div className={styles.CoachDecision}>
      {isCoach && (
        <div className={styles.top_header}>
          <img
            width="60"
            height="60"
            src="/images/decision.png"
            alt="decision--v1"
          />
          <h1 className={styles.main_text}>DEBATE WINNER DECISION</h1>
        </div>
      )}
      {displayResult && (
        <div className={styles.decision_header}>
          <WinnerTeamComp
            winnerTeam={judgeDecision.winnerTeamname}
            result={judgeDecision.result}
            debateType={debateType}
          />
        </div>
      )}
      {isWaitingForCoachDecision && (
        <div className="flex flex-col items-center">
          <svg
            className={styles.loadingSvg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            id="loading"
          >
            <path
              fill="#414042"
              d="M29.89 15.81a2.51 2.51 0 1 0-5 .45 9.65 9.65 0 0 1-1.68 6.34 10.24 10.24 0 0 1-5.74 4 10.71 10.71 0 0 1-7.38-.7 11.44 11.44 0 0 1-5.48-5.62A12.07 12.07 0 0 0 9.46 27 12.58 12.58 0 0 0 17.9 29a13.31 13.31 0 0 0 8.18-4 14 14 0 0 0 3.81-8.75v-.08A2.29 2.29 0 0 0 29.89 15.81zM7.11 15.74A9.65 9.65 0 0 1 8.79 9.4a10.24 10.24 0 0 1 5.74-4 10.71 10.71 0 0 1 7.38.7 11.44 11.44 0 0 1 5.48 5.62A12.07 12.07 0 0 0 22.54 5 12.58 12.58 0 0 0 14.1 3 13.31 13.31 0 0 0 5.92 7a14 14 0 0 0-3.81 8.75v.08a2.29 2.29 0 0 0 0 .37 2.51 2.51 0 1 0 5-.45z"
              data-name="Loading 19"
            />
          </svg>
          <p className={styles.desc_text}>
            Coaches are deciding the winner, please wait...
          </p>
        </div>
      )}

      {displayDecisionDashboard && (
        <DecisionBox
          JudgeDebate={JudgeDebate}
          debateType={debateType}
          teams={teams}
          result={judgeDecision.result || {}}
          debateState={debateState}
          dispatch={dispatch}
          winTeamName={judgeDecision.winnerTeamname}
        />
      )}
    </div>
  );
};

export const WinnerTeamComp = ({ winnerTeam, debateType, result }) => {
  return (
    <div className={styles.winnerTeamComp}>
      <div className={styles.winnerBox}>
        {debateType === debateFormatEnum["British Parliamentary"] ? (
          <div className="flex gap-x-5 mx-auto">
            {Object.keys(result).map((position) => (
              <div
                key={position} // Added key prop to fix React warning
                className="flex items-center shadow-sm rounded-md h-[80px] justify-center gap-x-5 px-10 border border-gray-200"
              >
                {/* <img
                  width="30"
                  height="30"
                  src={positionIcons[position]}
                  alt={position}
                /> */}
                <div className="flex items-center gap-x-2">
                  {/* <img
                    width="30"
                    height="30"
                    src="https://img.icons8.com/3d-fluency/94/user-group-man-woman--v1.png"
                    alt="user-group-man-woman--v1"
                  /> */}
                  <h1 className="font-bold text-xl">{positionIcons[position]}</h1>

                  <p className="font-bold text-2xl">{result[position]}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center">
            <img
              width="64"
              height="64"
              src="https://img.icons8.com/3d-fluency/94/confetti.png"
              alt="confetti"
            />
            <h1 className={styles.winText}>
              <span className={styles.winnerName}>{winnerTeam}</span> won the
              debate!!
            </h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default CoachDecision;
